import C from "@/components/modal/Dialog.module.css";

import { FormSubmitButton, type FormSubmitButtonProps } from "@/components/forms/FormSubmitButton.tsx";
import { WHookForm, type WHookFormProps } from "@/components/forms/WHookForm.tsx";
import {
    WModalContentSimple,
    WModalFooter,
    type WModalContentSimpleProps,
    type WModalFooterProps,
} from "@/components/modal/WModal.tsx";
import { cn } from "@/utils/classNames.ts";
import type { FieldValues } from "react-hook-form";

export interface WModalFormProps<T extends FieldValues> extends Omit<WHookFormProps<T>, "title" | "label"> {
    className?: string | undefined;

    title: WModalContentSimpleProps["title"];
    label: FormSubmitButtonProps["label"];

    footerNotice?: WModalFooterProps["footerNotice"];
    isActionDisabled?: boolean;

    buttonProps?: Omit<FormSubmitButtonProps, "label" | "isDisabled">;
    modalProps?: Omit<WModalContentSimpleProps, "children" | "title" | "className">;
}

export function WModalForm<T extends FieldValues>({
    className,
    children,
    onSubmit,
    footerNotice,
    form,
    title,
    label,
    isActionDisabled,
    buttonProps,
    modalProps,
    ...props
}: WModalFormProps<T>) {
    return (
        <WModalContentSimple title={title} {...modalProps}>
            {(close) => (
                <WHookForm
                    form={form}
                    onSubmit={async (v) => {
                        await onSubmit(v);

                        // NB: This will not be executed if onSubmit throws
                        close();
                    }}
                    {...props}
                >
                    {/* NB: Assumes children will have their own padding */}
                    <div className={className}>
                        <div className={cn("p-3", C.Scroll)}>{children}</div>
                        <WModalFooter footerNotice={footerNotice}>
                            <FormSubmitButton label={label} isDisabled={isActionDisabled} {...buttonProps} />
                        </WModalFooter>
                    </div>
                </WHookForm>
            )}
        </WModalContentSimple>
    );
}
